module.exports = __webpack_public_path__ + "img/icon-wx.238c84ee.png";